export const LoadingSpinnerIcon = () => {
  // Calculate positions using radial coordinates
  const centerX = 9;
  const centerY = 9;
  const radius = 7;
  const numCircles = 12;

  const circles = [];
  for (let i = 0; i < numCircles; i++) {
    const angle = (i * 30 - 90) * (Math.PI / 180); // Start from top, convert to radians
    const x = centerX + radius * Math.cos(angle);
    const y = centerY + radius * Math.sin(angle);
    const delay = (i * 0.1).toFixed(1);

    circles.push(
      <circle
        key={i}
        cx={x.toFixed(2)}
        cy={y.toFixed(2)}
        r="1.5"
        fill="#D0A9EF"
        opacity="0.1"
        style={{
          animation: 'pulse 1.2s ease-in-out infinite',
          animationDelay: `${delay}s`,
        }}
      />,
    );
  }

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <style>{`
          @keyframes pulse {
            0%, 100% { opacity: 0.1; }
            8.33% { opacity: 1; }
          }
          
          @media (prefers-reduced-motion: reduce) {
            circle {
              animation: none !important;
              opacity: 0.6 !important;
            }
          }
        `}</style>
      </defs>
      <g>{circles}</g>
    </svg>
  );
};
